import { useContext } from "react";
import AuditLabelContext from "./AuditLabelContext";
import { AuditLabelFunction, auditLabel} from "./withAuditLabel";

export default function useAuditLabel(): AuditLabelFunction {
    const { resources } = useContext(AuditLabelContext);
    return (controller, action, fieldName) => {
        return auditLabel(resources, controller, action, fieldName);
    }
}